import React, { useState, useEffect, useContext } from "react";
import { SiteContext } from "../contexts/SiteContext";
import { Link } from "react-router-dom";
import { Button, MenuItem, useTheme, makeStyles } from "@material-ui/core";
import Menu from "material-ui-popup-state/HoverMenu";
import PopupState, { bindHover, bindMenu } from "material-ui-popup-state";

const useStyles = makeStyles({
	subLink: {
		paddingLeft: '2rem'
	}
})

function NavMenu() {
	const theme = useTheme();
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);
	const [menu, setMenu] = useState();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchMenu = async () => {
			let res = await fetch(
				`${process.env.REACT_APP_API_URL}/menus?site=${selectedSite._id}`,
				{ credentials: "include" }
			);
			res = await res.json();
			if (res.success) {
				if (res.data.length < 1) {
					alert(
						`No menu found for this site. Please contact webmaster@lva.virginia.gov`
					);
				}
				setMenu(res.data[0]);
				setLoading(false);
			} else {
				console.log(res.error);
			}
		};
		fetchMenu();
	}, [selectedSite]);

	if (loading && !selectedSite) {
		return "Loading...";
	}

	return (
		<>
			{menu &&
				menu.links.map((mainLink, i) => {
					return (
						<PopupState key={i} variant="popover" popupId={`popup-${i}`}>
							{(popupState) => (
								<React.Fragment>
									<Button
										disableElevation
										variant="contained"
										style={{
											color: theme.palette.primary.contrastText,
											background: popupState.isOpen
												? selectedSite.secondaryColor
													? selectedSite.secondaryColor
													: theme.palette.primary.main
												: selectedSite.primaryColor
													? selectedSite.primaryColor
													: theme.palette.secondary.main,
										}}
										{...bindHover(popupState)}
										component={Link}
										to={mainLink.url}
									>
										{mainLink.title}
									</Button>
									{mainLink.children && mainLink.children.length > 0 && (
										<Menu
											{...bindMenu(popupState)}
											disableAutoFocusItem
											getContentAnchorEl={null}
											anchorOrigin={{
												vertical: "bottom",
												horizontal: "left",
											}}
											transformOrigin={{
												vertical: "top",
												horizontal: "left",
											}}
										>
											{mainLink.children.map((childLink, index) => {
												return (
													<MenuItem
														key={index}
														onClick={popupState.close}
														component={Link}
														to={childLink.url}
														className={`${childLink.isSubLink && classes.subLink}`}
													>
														{childLink.title}
													</MenuItem>
												);
											})}
										</Menu>
									)}
								</React.Fragment>
							)}
						</PopupState>
					);
				})}
		</>
	);
}

export default NavMenu;
